import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import LocaleSettingsLink from '../../../components/LocaleSettingsLinks/LocaleSettingsLink';

export const LeanLocaleSettingsLink = () => (
    <Container>
        <LocaleSettingsLink shortenedLabel />
    </Container>
);
